import { render, staticRenderFns } from "./alarmTask.vue?vue&type=template&id=1b08f176&scoped=true&"
import script from "./alarmTask.vue?vue&type=script&lang=js&"
export * from "./alarmTask.vue?vue&type=script&lang=js&"
import style0 from "./alarmTask.vue?vue&type=style&index=0&id=1b08f176&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b08f176",
  null
  
)

export default component.exports